module.exports = __webpack_public_path__ + "img/1f612.75033cf.svg";